import React, { FC } from 'react'

import clsx from 'clsx'

import { Txt, Icon, LoadingIcon } from 'src/components/atoms'

import { RequireOne } from 'src/types'

type ChildrenType = RequireOne<{
  text?: string
  children?: React.ReactNode
}>

export type ButtonInnerProps = {
  buttonType: 'primary' | 'secondary' | 'tertiary' | 'danger' | 'conversion'
  size?: 's' | 'm' | 'l'
  prependIconPath?: string
  appendIconPath?: string
  isLoading?: boolean
  disabled?: boolean
} & ChildrenType
export const ButtonInner: FC<ButtonInnerProps> = ({
  buttonType,
  size = 'm',
  children,
  text,
  prependIconPath,
  appendIconPath,
  isLoading = false,
  disabled,
}) => {
  return (
    <div>
      {children || (
        <span className={clsx(`tw-centering`, (isLoading || disabled) && 'tw-cursor-default')}>
          {prependIconPath && (
            <div className="tw-mr-r-3">
              {isLoading ? (
                <LoadingIcon />
              ) : (
                <Icon
                  size="--r1"
                  path={prependIconPath}
                  className={clsx(buttonType === 'secondary' && 'tw-text-standardText-secondary')}
                />
              )}
            </div>
          )}
          <Txt sizeType={size}>{text}</Txt>
          {appendIconPath && (
            <div className="tw-ml-r-3">
              {isLoading ? (
                <LoadingIcon />
              ) : (
                <Icon
                  size="--r1"
                  path={appendIconPath}
                  className={clsx(buttonType === 'secondary' && 'tw-text-standardText-secondary')}
                />
              )}
            </div>
          )}
        </span>
      )}
    </div>
  )
}
